import ReportTable from '../../../../../components/Grid/ReportTable';

export default function ProdutosTable(props: any) {
  return <ReportTable model={props.model} columnCount={7} />;
}
